import Cookies from 'js-cookie';

class CookieShopVisitedService {
  _shopVisitedCookieName = 'is-shop-visited';

  _setDomain() {
    const isWebTest = window.location.host.indexOf('webtest') !== -1;

    if (isWebTest) {
      return 'vimpelcom.ru';
    }

    return 'beeline.ru';
  }

  _getCookie() {
    return Cookies.get(this._shopVisitedCookieName);
  }

  _setCookie(value) {
    const domain = this._setDomain();

    const options = {
      domain,
    };

    Cookies.set(this._shopVisitedCookieName, value, options);
  }

  getVisited() {
    const isVisited = this._getCookie();
    if (!isVisited) {
      this._setCookie('true');
    }
    return !!isVisited;
  }
}

export const cookieShopVisitedService = new CookieShopVisitedService();
